import { safeDeleteSheet } from "@/lib/office-helpers";

export async function startProject1(): Promise<void> {
  await Excel.run(async (context) => {
    await safeDeleteSheet(context, "Asistencia de Visitantes");
    await safeDeleteSheet(context, "Actividades-Guardabosques");
    await safeDeleteSheet(context, "Programas por Parque");

    // SHEET 1 - Asistencia de Visitantes
    const sheet = context.workbook.worksheets.add("Asistencia de Visitantes");
    const table = sheet.tables.add("A3:G3", true);
    table.name = "Asistencia";
    table.getHeaderRowRange().values = [
      ["Parque Nacional", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio"],
    ];
    table.style = "TableStyleMedium4";
    table.rows.add(undefined, [
      ["Arches", 11099, 16426, 73935, 108086, 149321, 154505],
      ["Bryce Canyon", 15788, 17572, 51205, 87023, 166592, 210292],
      ["Canyonlands", 6587, 4157, 35930, 54979, 75369, 53996],
      ["Capitol Reef", 5915, 7608, 39512, 53120, 114082, 90063],
      ["Zion", 57976, 65820, 227899, 292765, 313594, 367217],
    ]);
    table.autoFilter.remove();

    sheet.getRange("A2").values = [
      ["Asistencia de Visitante a los Parques Nacionales de Utah"],
    ];
    sheet.getRange("A2:G2").merge();
    sheet.getRange("A2:G2").format.font.size = 16;
    sheet.getRange("A2").format.horizontalAlignment = "Center";

    sheet.getUsedRange().format.autofitColumns();
    sheet.getUsedRange().format.autofitRows();

    sheet.getRange("A12").values = [["Promedio de Asistencia:"]];
    sheet.getRange("A12:B12").merge();
    const range2 = sheet.getRange("A12:B12");
    const borders = range2.format.borders;
    (["EdgeTop", "EdgeBottom", "EdgeLeft", "EdgeRight"] as const).forEach(
      (edge) => {
        borders.getItem(edge).style = "Continuous";
      }
    );
    range2.format.horizontalAlignment = "Center";
    range2.format.font.bold = true;
    sheet.getRange("B:G").format.columnWidth = 70;
    sheet.getRange("A1").select();
    sheet.activate();
    await context.sync();

    // SHEET 2 - Actividades-Guardabosques
    const sheet2 = context.workbook.worksheets.add("Actividades-Guardabosques");
    const table2 = sheet2.tables.add("A3:F3", true);
    table2.name = "Guardabosques";
    table2.getHeaderRowRange().values = [
      [
        "Programas dirigidos por guardabosques",
        "Programas Juveniles",
        "Programas de Noche",
        "Parque Nacional",
        "Programa de Astronomia",
        "Programas Juveniles y Astronomia",
      ],
    ];
    table2.style = "TableStyleMedium4";
    table2.rows.add(undefined, [
      ["Primavera, Otono", "Ninguno", "Primavera, Otono", "Arches", "No", ""],
      ["Primavera, Verano, Otono", "Verano", "Verano, Otono", "Bryce Canyon", "Si", ""],
      ["Primavera, Verano, Otono", "Ninguno", "Primavera, Verano, Otono", "Canyonlands", "Si", ""],
      ["Primavera, Verano, Otono", "Primavera, Verano, Otono", "Primavera, Verano, Otono", "Capitol Reef", "Si", ""],
      ["Primavera, Verano, Otono", "Primavera, Verano, Otono", "Primavera, Verano, Otono", "Zion", "No", ""],
    ]);
    table2.autoFilter.remove();

    sheet2.getRange("A2").values = [["Actividades Dirigidas por Guardabosques"]];
    sheet2.getRange("A2:F2").merge();
    sheet2.getRange("A2:F2").format.font.size = 20;
    sheet2.getRange("A2:F2").format.horizontalAlignment = "Center";
    sheet2.getUsedRange().format.autofitColumns();
    sheet2.getUsedRange().format.autofitRows();
    sheet2.getRange("A1").select();

    // SHEET 3 - Pivot Table
    const sheet3 = context.workbook.worksheets.add("Programas por Parque");
    const guardabosquetabla = context.workbook.tables.getItem("Guardabosques");
    const destinoRango = sheet3.getRange("B2");
    const newPivotTable = sheet3.pivotTables.add(
      "TablaDinamica2",
      guardabosquetabla,
      destinoRango
    );

    newPivotTable.hierarchies.load("items/name");
    await context.sync();

    async function ensureHierarchyAdded(name: string) {
      const h = newPivotTable.rowHierarchies.getItemOrNullObject(name);
      await context.sync();
      if (h.isNullObject) {
        newPivotTable.rowHierarchies.add(
          newPivotTable.hierarchies.getItem(name)
        );
      }
    }

    await ensureHierarchyAdded("Parque Nacional");
    await ensureHierarchyAdded("Programa de Astronomia");
    await context.sync();

    sheet.activate();
    sheet.getRange("A1").select();
  });
}
